import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import moment from "moment";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const LineChart = ({ chartData }) => {
  const updateDatasets = chartData.yearlyBasedStatistics.map((value, index) => {
    return {
      label: value.year,
      data: value.dataSet,
      borderColor: value.color,
      backgroundColor: value.color,
      pointRadius: 0,
      fill: true,
      percentage: value.percentage
    }
  })



  const verticalLinePlugin = {
    id: "verticalLine",
    afterDraw(chart) {
      if (chart.tooltip && chart.tooltip._active && chart.tooltip._active.length) {
        const ctx = chart.ctx;
        const activePoint = chart.tooltip._active[0].element;
        const x = activePoint.x;
        const y = activePoint.y;
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(x, y);
        ctx.lineTo(x, chart.scales.y.bottom);
        ctx.lineWidth = 1;
        ctx.strokeStyle = "#191549";
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x, y, 4, 0, 2 * Math.PI);
        ctx.fillStyle = "#191549";
        ctx.fill();
        ctx.stroke();
        ctx.restore();
      }
    },
  };



  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          color: "#768B9F",
          font: {
            size: 14,
            family: "Satoshi"
          },
          boxWidth: 10,
          padding: 30,
          boxHeight: 10,
        },
      },
      
      tooltip: {
        backgroundColor: "rgba(25, 21, 73, 0.90)",
        minWidth: 230,
        mode: chartData.percentage ? "index" :"nearest",
        intersect: false,
        caretPadding: 10,
        titleAlign: "center",
        titleFont: {
          size: 17, // Change this value to adjust font size
          weight: "bold", // You can also set font weight
        },
        padding: {
          left: 25,
          right: 30,
          top: 10,
          bottom: 10,
        },
        callbacks: {
        
          title: function (tooltipItems) {
            if (chartData.percentage) {
              return `${tooltipItems[0].label} .${" "} ${tooltipItems[0].formattedValue}%`;
            }
            else {
              return `$${tooltipItems[0].formattedValue}`;
            }
          },
          label: function (context) {
            if (chartData.percentage) {
              if (context.datasetIndex == 1) {
                return `Previous Year . ${context.formattedValue}%`
              }
              else {
                return ""
              }
            }
            else {
              return `${context.label}`;
            }
          },
        },
        displayColors: false,
      },
    },
    hover: {
      mode: "nearest",
      intersect: true,
    },
    scales: {
      x: {
        border: {
          display: false,
        },
        grid: {
          color: "#BEC2C5",
        },
        ticks: {
          callback: function (value, index, ticks) {
            const label = this.getLabelForValue(value); // Get the label for the current tick
            if (typeof label === "string") {
              const parts = label?.split(" ");
              if (parts?.length > 1) {
                return [parts[1], parts[0]];
  
              }
              else {
                return [label]
              }
          } else {
            return label
          }
          
            
          },
          color: "#A7AFB7",
        },
        offset: true,
      },
      y: {
        border: {
          display: false,
        },
        grid: {
          drawOnChartArea: false, // Removes background grid lines
          drawTicks: false,
          display: false, // Disable horizontal grid lines
        },
        ticks: {
          callback: function (value, index, ticks) {
            const label = this.getLabelForValue(value);
            if (chartData.percentage) {
              return `${label}%`
            }
            else {
              return `${parseInt(label.replace(/,/g, ""), 10)/ 1000}k`
            }
          },
          color: "#A7AFB7",
        },
      },
    },

    elements: {
      line: {
        tension: 0.4,
      },
      point: {
        radius: 5,
        hoverRadius: 7,
        backgroundColor: function (context) {
          return context.dataset.borderColor;
        },
      },
    },
  };

  const data = {
    labels: chartData.labels,
    datasets: updateDatasets,
  };

  return (
    <div>
      <Line options={options} data={data} plugins={[verticalLinePlugin]} />
    </div>
  );
};

export default LineChart;